import axios from "axios";
import {
    authorizationServicesPath,
} from "../../Constants";

const jobRestUrl = authorizationServicesPath + '/customers/organization-rating-indicator/get-all'

export default class RatingIndicator {
    static async getAll() {
        return axios.get(jobRestUrl);
    }
}